import { useCallback, useEffect, useState } from 'react';
import { fetchTracksForStudent } from '../../services/StudentTracksService';

/**
 * A student's `studentTracks` docs for a staff surface: one read per student,
 * re-run when the student changes (the lesson can be linked to a student after
 * it opens). Fails quiet — a track strip that did not load is an empty strip,
 * and the lesson must not error over a pointer set that is optional on most
 * songs. The family Songs page runs the same service; the rule lets staff
 * through on `viewStudents`.
 */
const useStudentTracks = (studentId) => {
	const [docs, setDocs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	// Bumped by reload() — "Add a track" (2026-09-26) calls it when a job it
	// is watching lands, so the new cut appears without leaving the lesson.
	const [version, setVersion] = useState(0);
	const reload = useCallback(() => setVersion((v) => v + 1), []);

	useEffect(() => {
		let cancelled = false;
		if (!studentId) {
			setDocs([]);
			return undefined;
		}
		setIsLoading(true);
		fetchTracksForStudent(studentId)
			.then((rows) => {
				if (!cancelled) setDocs(rows);
			})
			.catch((err) => {
				console.error('Error loading student tracks:', err);
				if (!cancelled) setDocs([]);
			})
			.finally(() => {
				if (!cancelled) setIsLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [studentId, version]);

	return { docs, isLoading, reload };
};

export default useStudentTracks;
